import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pet, PetResidenceStatus, PetStatus } from 'src/app/interfaces/pet';
import { PetService } from 'src/app/services/pet/pet.service';
import { DECEASED_PET_NUMBER_OF_DAYS_TO_SHOW } from 'src/app/constants/app.constants';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-my-pets',
  templateUrl: './my-pets.component.html',
  styleUrls: ['./my-pets.component.scss']
})
export class MyPetsComponent {

  pets: Array<any> = [];
  petStatus = PetStatus;
  petResidenceStatus = PetResidenceStatus;
  public filteredListOfPets: Pet[] = [];
  public showArchivedPets: boolean = false;
  isBrowser: boolean;

  constructor(
    private route: ActivatedRoute,
    private _petService: PetService,
    private cloudinaryService: CloudinaryService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.pets = this.route.snapshot.data.user.pets;
    this.filteredListOfPets =
      this._petService.getListOfPetsBasedOnLifeStatusAndDate(this.route.snapshot.data.user.pets, DECEASED_PET_NUMBER_OF_DAYS_TO_SHOW, this.showArchivedPets);
    this.isBrowser = isPlatformBrowser(this.platformId);
    
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  public onShowArchivedChanged(event: MatSlideToggleChange) {
    this.showArchivedPets = event.checked;
    this.filteredListOfPets =
      this._petService.getListOfPetsBasedOnLifeStatusAndDate(this.route.snapshot.data.user.pets, DECEASED_PET_NUMBER_OF_DAYS_TO_SHOW, this.showArchivedPets);
  }
  
  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 360, 360, '/assets/images/placeholders/paw-square-image.png');
  }

  public navigateToPetDetailPage(petId: string) {
    return `/my-pet/${petId}`;
  }
}
